import * as React from 'react'
import { Box, Divider, Icon, styled } from '@design/pt-ui'
import { IStringTMap } from '../types/map'
import {
  FieldValidation,
  FormBlueprint,
} from '../interfaces/components/dynamic-form'
import {
  getBlueprintAtPath,
  splitPath,
  joinPath,
  walkBlueprint,
} from '../lib/dynamic-form/helpers'
import { padNumbersInString } from '../utils/string'
import { arrayPathFlobulator } from '../utils/object'

const ContentWarning = styled('div')({
  display: 'flex',
  justifyContent: 'baseline',
  alignItems: 'center',
})

interface IValidationMessages {
  fields: IStringTMap<FieldValidation>
  blueprint: FormBlueprint
}

function ValidationMessages(props: IValidationMessages) {
  const { fields, blueprint } = props

  const getLabels = (splited: string[]) => {
    let labels = ''
    let keys: string[] = []
    splited.forEach((key) => {
      keys.push(key)
      const joinedKeys = joinPath(keys)
      const fieldBlueprint = getBlueprintAtPath(blueprint, joinedKeys)
      const label = fieldBlueprint ? fieldBlueprint.label : key

      if (labels === label && key.includes('[') && key.includes(']')) {
        const [beg, end] = [key.indexOf('[') + 1, key.indexOf(']')]
        const index = Number(key.substring(beg, end)) + 1
        labels += ` (${index}) `
      } else {
        labels += label
      }
    })
    return labels
  }

  const unsortedKeys = Object.keys(fields)
  let sortedKeys: string[] = []
  walkBlueprint(blueprint, (_fieldBlueprint, path) => {
    let matching: string[] = []

    for (const key of unsortedKeys) {
      const flobulated = arrayPathFlobulator(key)
      if (flobulated === path) {
        matching.push(key)
      }
    }

    matching.sort((a, b) => {
      const padded = {
        a: padNumbersInString(a, 9),
        b: padNumbersInString(b, 9),
      }

      if (padded.a < padded.b) {
        return -1
      }

      if (padded.a > padded.b) {
        return 1
      }

      return 0
    })

    sortedKeys = [...sortedKeys, ...matching]
  })

  const messages = sortedKeys.map((key) => {
    const splited = splitPath(key)
    const labels = getLabels(splited)

    return (
      <div key={key}>
        <h3>{labels}</h3>
        {fields[key].map((msg, i) => {
          if (msg.status === 'warning') {
            const message = msg.message
            return (
              <div key={`${key}-msg-${msg.status}-${i}`}>
                <ContentWarning>
                  <Icon
                    sx={{ fontSize: 150, color: 'warning.main', mr: '10px' }}>
                    priority_high
                  </Icon>
                  <span>{message}</span>
                </ContentWarning>
                <Divider />
              </div>
            )
          }

          if (msg.status === 'error') {
            const message = msg.message

            return (
              <React.Fragment key={`${key}-msg-${msg.status}-${i}`}>
                <ContentWarning>
                  <Icon sx={{ fontSize: 150, color: 'error.main', mr: '10px' }}>
                    warning
                  </Icon>
                  <span>{message}</span>
                </ContentWarning>
                <Divider />
              </React.Fragment>
            )
          }

          return null
        })}
      </div>
    )
  })

  return <Box>{messages}</Box>
}

export default ValidationMessages
